import React , { Component } from 'react'
class Work extends Component{
	

	render(){
		const imgLink = this.props.imgLink
		return(
			<div className="work-img">
				{
					this.props.type 
						? <iframe width="100%" height="200px" src={this.props.embedLink} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						: <img src={imgLink} className="work-photo" alt={this.props.key} onMouseEnter={()=> this.onHoverImage(this.props.id)}/>
					} 
				<div className="work-overlay" id={this.props.id}>
					<h2>{this.props.title}</h2>
					<h4>{this.props.tech}</h4>
				</div>
			</div>
		)
	}
}
export default Work